import React, { useState } from 'react'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'

const CourseCreationNonAttachmentView = props => {
  const {
    classes,
    fileInputRef,
    handleOnDropFile,
    handleFileSelect,
    attachmentLoading,
  } = props
  const dispatch = useDispatch()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onDrop={handleOnDropFile}
      onDragOver={e => e.preventDefault()}
      className={classes.root}
      onClick={() => {
        // Trigger the Add AddSourceModal via the parent prop if passed?
        // Wait, the onClick logic was in the button before.
        // In the previous step, I passed `onAddSource` to this component and used it on the button.
        // Now the whole card is clickable.
        // I need to ensure `onAddSource` is passed and used.
        if (props.onAddSource) {
          props.onAddSource()
        }
      }}
    >
      {attachmentLoading ? (
        <CircularProgress size={32} />
      ) : (
        <div className={classes.contentSection}>
          <Icon
            icon="tabler:file-text"
            className={classes.icon}
            style={{ fontSize: '22px' }}
          />

          <div className={classes.textSection}>
            <Typography className={classes.title}>
              Select from recent sources or upload
            </Typography>
            <Typography className={classes.subtitle}>
              Supported sources: PDF, YouTube video
            </Typography>
          </div>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(CourseCreationNonAttachmentView)
